var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('van-action-sheet', {
    attrs: {
      "get-container": "body",
      "lazy-render": false
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "vnp-header"
  }, [_c('button', {
    staticClass: "vnp-btn-finish",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("完成")])]), _c('div', {
    staticClass: "vnp-input-box-outer"
  }, [_c('vnp-input-box', {
    ref: "inputBox",
    attrs: {
      "len": _vm.len,
      "codeType": _vm.codeType,
      "editable": ""
    },
    on: {
      "activeChange": _vm.handleActiveChange
    },
    model: {
      value: _vm.val,
      callback: function callback($$v) {
        _vm.val = $$v;
      },
      expression: "val"
    }
  })], 1), _c('div', {
    staticClass: "vnp-keys"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "vnp-keys-row"
    }, _vm._l(item, function (val, index) {
      return _c('div', {
        key: index,
        staticClass: "vnp-btn-key-wrapper",
        class: {
          'vnp-del-wrapper': val === 'del',
          'vnp-type-wrapper': val === 'type'
        }
      }, [val === 'type' ? _c('van-button', {
        staticClass: "vnp-btn-key",
        on: {
          "click": _vm.handleChangeType
        }
      }, [_c('span', [_vm._v("英")])]) : val === 'del' ? _c('van-button', {
        staticClass: "vnp-btn-key",
        on: {
          "click": _vm.handleDel
        }
      }, [_c('svg', {
        staticClass: "vnp-delete-icon",
        attrs: {
          "viewBox": "0 0 32 22",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "d": "M28.016 0A3.991 3.991 0 0132 3.987v14.026c0 2.2-1.787 3.987-3.98 3.987H10.382c-.509 0-.996-.206-1.374-.585L.89 13.09C.33 12.62 0 11.84 0 11.006c0-.86.325-1.62.887-2.08L9.01.585A1.936 1.936 0 0110.383 0zm0 1.947H10.368L2.24 10.28c-.224.226-.312.432-.312.73 0 .287.094.51.312.729l8.128 8.333h17.648a2.041 2.041 0 002.037-2.04V3.987c0-1.127-.915-2.04-2.037-2.04zM23.028 6a.96.96 0 01.678.292.95.95 0 01-.003 1.377l-3.342 3.348 3.326 3.333c.189.188.292.43.292.679 0 .248-.103.49-.292.679a.96.96 0 01-.678.292.959.959 0 01-.677-.292L18.99 12.36l-3.343 3.345a.96.96 0 01-.677.292.96.96 0 01-.678-.292.962.962 0 01-.292-.68c0-.248.104-.49.292-.679l3.342-3.348-3.342-3.348A.963.963 0 0114 6.971c0-.248.104-.49.292-.679A.96.96 0 0114.97 6a.96.96 0 01.677.292l3.358 3.348 3.345-3.348A.96.96 0 0123.028 6z",
          "fill": "currentColor"
        }
      })])]) : _c('van-button', {
        staticClass: "vnp-btn-key",
        class: {
          'vnp-btn-empty': !val
        },
        on: {
          "click": function click($event) {
            return _vm.handleClickKey(val);
          }
        }
      }, [_vm._v("\n            " + _vm._s(val) + "\n          ")])], 1);
    }), 0);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };